import { Injectable } from '@angular/core';
import {Http, Response} from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { Headers, RequestOptions } from '@angular/http';
import {State} from "../model/State";
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";


@Injectable()
export class StateService {

    stateUrl = environment.instantPaiementApi + "states";

    constructor(private http: Http,
                private authenticationService: AuthenticationService) {}

    getListStates(): Promise<State[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.get(this.stateUrl, options)
            .toPromise()
            .then(response => response.json() as State[])
            .then(undefined, (error) => { console.error(error); })
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || { };
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/state.service.ts